import { lazy } from 'react';
export const LazySignUpPage = lazy(() => import('./sign-up/sign-up'));
export const LazyForgotPasswordPage = lazy(() => import('./forgot-password'));
export const LazyNewAccountPage = lazy(() => import('./new-account'));
export const LazyTeacherHome = lazy(
  () => import('./teacher-home/teacher-home')
);
export const LazyStudentHome = lazy(
  () => import('./student-home/student-home')
);
export const LazyResources = lazy(() => import('./resources/resources'));

export const LazyAdmin = lazy(() => import('./admin-home/admin-home'));
